import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage, roleAccess, userRoles } from "./constants";

// Guarda de la vista del budget generator: solo entran los distribuidores.
const DistributorValidation = () => {
  const [redirectTo, setRedirectTo] = useState("");
  const isLoggedIn = useSelector(({ user }) => user.isLoggedIn);
  const userRole = useSelector(({ user }) => user.userRole);

  useEffect(() => {
    if (!isLoggedIn) {
      return setRedirectTo(`${pathHomePage}/`);
    }
    // Un usuario de Eodyne que llegue aqui vuelve a su propia pantalla.
    if (userRole !== userRoles.DISTRIBUTOR) {
      const access = roleAccess[userRole];
      setRedirectTo(`${pathHomePage}${access ? access.landingPage : "/"}`);
    }
  }, [isLoggedIn, userRole]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }
};

export default DistributorValidation;
